<template>
  <div class="custom-input">
    <input
      :type="inputType"
      class="custom-input__element"
      :id="inputId"
      :name="inputName"
      @input="fireInputEvent"
      :value="inputValue"
      ref="inputElement"
    />
    <label :for="inputId" class="custom-input__label">
      <span class="custom-input__ring-span text-primary"></span>
      <slot name="label-content" />
    </label>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue'

const props = defineProps<{
  inputType: 'checkbox' | 'radio'
  inputValue: string
  inputName: string
  inputId: string
  initialValue?: string
}>()
const inputElement = ref<HTMLInputElement>()
const checkedInputValue = ref<any>(null)

const emits = defineEmits<{
  (e: 'input-event', val: HTMLInputElement): void
}>()

const fireInputEvent = (e: Event) => {
  const target = e.currentTarget as HTMLInputElement
  checkedInputValue.value = target.value
  emits('input-event', target)
}

onMounted(() => {
  if (!!props.initialValue) {
    checkedInputValue.value = props.initialValue
    if (inputElement.value) {
      if (props.initialValue === inputElement.value.value) {
        inputElement.value.click()
      }
    }
  }
})
</script>

<style scoped lang="scss"></style>
